import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trans, withClientConfig } from '@spotahome/soyuz/client';

import DatesInput from '../../../../common/components/DatesInput';

const datesInputStyling = {
  from: 'ga-search-form-datepicker-from',
  to: 'ga-search-form-datepicker-to',
  container: 'form-datepicker__container'
};

class FormDatePicker extends Component {
  onDateSelect = dates => {
    const mapped = {
      'move-in': dates.moveIn
    };

    if (dates.moveOut) {
      mapped['move-out'] = dates.moveOut;
    }

    this.props.onChange(mapped);
  };

  render() {
    const {
      autoCompleteDates,
      clientConfig,
      disableDayFnFrom,
      disableDayFnTo,
      flexibleDates,
      fromDate,
      minimumStaying,
      toDate
    } = this.props;

    const datesInputTexts = {
      moveInPlaceholder: trans('search.filter.date_in'),
      moveOutPlaceholder: trans('search.filter.date_out')
    };

    return (
      <DatesInput
        autoCompleteDates={autoCompleteDates}
        dateFormat={clientConfig.dateFormat}
        disableMoveIn={disableDayFnFrom}
        disableMoveOut={disableDayFnTo}
        flexibleDates={flexibleDates}
        minStay={minimumStaying}
        moveIn={fromDate}
        moveOut={toDate}
        onChange={this.onDateSelect}
        styling={datesInputStyling}
        texts={datesInputTexts}
      />
    );
  }
}

const clientConfigShape = {
  dateFormat: PropTypes.string
};

const flexibleDatesShape = {
  flexibleMoveIn: PropTypes.bool,
  flexibleMoveOut: PropTypes.bool,
  onFlexibleMoveInChange: PropTypes.func,
  onFlexibleMoveOutChange: PropTypes.func
};

FormDatePicker.propTypes = {
  autoCompleteDates: PropTypes.bool,
  clientConfig: PropTypes.shape(clientConfigShape).isRequired,
  disableDayFnFrom: PropTypes.func,
  disableDayFnTo: PropTypes.func,
  flexibleDates: PropTypes.shape(flexibleDatesShape),
  fromDate: PropTypes.string,
  minimumStaying: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  toDate: PropTypes.string
};

FormDatePicker.defaultProps = {
  autoCompleteDates: false,
  disableDayFnFrom: () => {},
  disableDayFnTo: () => {},
  flexibleDates: null,
  fromDate: '',
  toDate: '',
  clientConfig: {
    alertModalCityAreaFilter: 'YYYY-MM-DD'
  }
};

export default withClientConfig()(FormDatePicker);
